<template>
  <v-app-bar id="app-bar" fixed app elevation="0" height="64" class="app-bar-clean">
    <v-btn icon class="menu-toggle mr-2" @click="setDrawer(!drawer)">
      <v-icon color="#4a5568" size="22">mdi-menu</v-icon>
    </v-btn>

    <v-toolbar-title class="hidden-sm-and-down route-title" v-text="$route.name" />

    <v-spacer />

    <!-- ภารกิจค้างจากศูนย์แจ้งเตือนสถานศึกษา (college_notification_center.php) -->
    <v-btn icon class="ml-1" :title="bellTitle" @click="goNotify">
      <v-badge
        :value="pendingCount > 0"
        :content="pendingCount"
        :color="urgentCount ? 'red darken-1' : 'orange darken-2'"
        overlap
      >
        <v-icon color="#4a5568">{{ pendingCount ? "mdi-bell-ring-outline" : "mdi-bell-outline" }}</v-icon>
      </v-badge>
    </v-btn>

    <v-btn class="nav-btn ml-2" text to="/college/Dashboard">
      <v-icon left color="#4a5568">mdi-view-dashboard-outline</v-icon>Dashboard
    </v-btn>
    <v-btn class="nav-btn ml-2" text to="/college/home_menu">
      <v-icon left color="#4a5568">mdi-apps</v-icon>เมนูระบบ
    </v-btn>

    <v-btn text class="logout-btn ml-2" @click="confirmLogout()">
      <v-icon left color="#e53e3e">mdi-logout</v-icon>ออกจากระบบ
    </v-btn>
  </v-app-bar>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  name: "DashboarduserAppBar",

  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return { pendingCount: 0, urgentCount: 0, loadedAt: 0 };
  },

  computed: {
    ...mapState(["drawer"]),
    bellTitle() {
      return this.pendingCount
        ? `ภารกิจที่ต้องดำเนินการ ${this.pendingCount} รายการ (เร่งด่วน ${this.urgentCount})`
        : "ไม่มีภารกิจค้าง";
    }
  },

  watch: {
    // เปลี่ยนหน้าแล้วโหลดใหม่ (อย่างมากนาทีละครั้ง) — ทำรายการเสร็จแล้วกลับมา ตัวเลขจะลดลงเอง
    $route() {
      if (Date.now() - this.loadedAt > 60000) this.loadPending();
    }
  },

  mounted() {
    this.loadPending();
    this.$root.$on("college-notify-summary", this.applySummary);
  },

  beforeDestroy() {
    this.$root.$off("college-notify-summary", this.applySummary);
  },

  methods: {
    ...mapMutations({
      setDrawer: "SET_DRAWER"
    }),
    async loadPending() {
      this.loadedAt = Date.now();
      try {
        const res = await this.$http.post("college_notification_center.php", { ApiKey: "HRvec2021" });
        if (res.data && res.data.status) this.applySummary(res.data.summary);
      } catch (e) {
        // กระดิ่งเป็นส่วนเสริม — โหลดไม่ได้ก็ไม่ต้องแจ้งผู้ใช้
      }
    },
    applySummary(summary) {
      this.loadedAt = Date.now();
      this.pendingCount = (summary && summary.todo) || 0;
      this.urgentCount = (summary && summary.urgent) || 0;
    },
    goNotify() {
      if (this.$route.path === "/college/home_menu") {
        const el = document.getElementById("notify");
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        this.$router.push("/college/home_menu");
      }
    },
    confirmLogout() {
      Swal.fire({
        title: "ออกจากระบบ",
        text: "คุณต้องการออกจากระบบหรือไม่?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#e53e3e",
        cancelButtonColor: "#a0aec0",
        confirmButtonText: "ออกจากระบบ",
        cancelButtonText: "ยกเลิก"
      }).then(result => {
        if (result.isConfirmed) {
          this.logout();
        }
      });
    },
    logout() {
      localStorage.clear();
      this.$router.push("/");
    }
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Prompt:wght@300;400;500;600;700&display=swap");

.app-bar-clean {
  background: #ffffff !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08) !important;
  font-family: "Prompt", sans-serif;
}

.route-title {
  font-size: 1rem;
  font-weight: 600;
  color: #263238;
}

.nav-btn,
.logout-btn {
  border-radius: 8px !important;
  color: #4a5568;
  transition: background 0.2s ease;
}

.nav-btn:hover {
  background: #f5f5f5 !important;
}

.logout-btn:hover {
  background: #fff5f5 !important;
}
</style>
